<template lang="pug">
  #challenge-builder-review
    WtTitle(h2) Final Step: Review Challenge Details

    WtTile(parent)
      WtTile(child child-class="")
        .columns.card.review-section
          .column.is-one-third
            BField(label="Challenge Type")
              BInput(:value="challengeTypeName" readonly)
          .column.is-one-third
            BField(label="Challenge Administrator")
              BInput(:value="$auth.user().username" readonly)
          .column.is-one-third
            BField(label="Challenge Between")
              BInput(:value="betweenText" readonly)

        .columns.card.review-section
          .column
            PreviewForm(preview-mode @validationResult="handleValidationResult($event)")

    ChallengeBuilderControls.controls(
      last-step
      :allow-next="enableCreate"
      @submit="submitChallengeCreation"
      :submit-clicked="submitClicked"
    )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import PreviewForm from "@@/ChallengeBuilder/ChallengeBuilderDefineForm";
import ChallengeBuilderTeamsTable from "@@/ChallengeBuilder/ChallengeBuilderTeamsTable";
import MembersTable from "@@/Members/MembersTable";
import ChallengeBuilderControls from "@@/ChallengeBuilder/ChallengeBuilderControls";

/**
 * Challenge Builder wrapper for Step 4, reviewing challenge
 */
export default {
  name: "ChallengeBuilderReview",

  components: {
    WtTile,
    WtTitle,
    PreviewForm,
    ChallengeBuilderTeamsTable,
    MembersTable,
    ChallengeBuilderControls
  },

  data() {
    return {
      validateForm: false,
      enableCreate: false,
      submitClicked: false,
      errorCreatingChallenge: false
    };
  },

  computed: {
    ...mapGetters("program", ["maps"]),
    ...mapGetters("challengeBuilder", ["formData"]),

    betweenText() {
      return this.formData.between.value === "groups" ? "Teams" : "Individuals";
    },

    isAdminBuilder() {
      return /admin/.test(this.$route.path);
    },

    isWellnessChallenge() {
      let map = this.maps.find(
        map => map.id === this._.get(this.formData, "mapId.value", null)
      );
      return this._.get(map, "isWellnessChallenge", false);
    },

    isPreventativeChallenge() {
      let map = this.maps.find(
        map => map.id === this._.get(this.formData, "mapId.value", null)
      );
      return this._.get(map, "isPreventativeChallenge", false);
    },

    isChartBasedChallenge() {
      return this._.get(this.formData, "mapId.value", null) === null;
    },

    challengeTypeName() {
      if (this.isWellnessChallenge) {
        return "Wellness Challenge";
      }
      if (this.isPreventativeChallenge) {
        return "Preventative Care";
      }
      if (this.isChartBasedChallenge) {
        return "Chart-based Challenge";
      }
      return "Map Based/Goal";
    }
  },

  methods: {
    ...mapActions("challengeBuilder", ["createChallenge"]),
    ...mapActions("program", ["fetchAllChallenges"]),
    ...mapActions(["snackBar"]),
    ...mapActions("pages", ["setPageLoaded", "fetchAllPageMyDashboard"]),

    handleValidationResult(result) {
      // if a value is updated makes sure that the submit button is disabled
      this.enableCreate = result;
    },

    async submitChallengeCreation() {
      this.submitClicked = true;

      try {
        const response = await this.createChallenge();
        if (this._.get(response, "data.success", false)) {
          // item is a challenge
          const item = response.data.data;

          this.fetchAllChallenges({
            programId: this.$auth.user().programId
          });
          this.setPageLoaded({ key: "Challenges", value: false });
          this.setPageLoaded({
            key: "MyDashboard",
            value: false
          });
          // start the requests so that if the user navigates to MyDashboard, the challenge shows up faster
          this.fetchAllPageMyDashboard(this.$auth.user());

          if (this.isAdminBuilder) {
            this.$router.push({ name: "ChallengeCenterSettings" });
          } else {
            this.$router.push({ name: "Challenges" });
          }

          this.snackBar({
            duration: 10000,
            message: `Challenge "${item.name}" successfully created!`,
            actionText: "VIEW",
            onAction: () => {
              this.$router.push({
                name: "Challenge",
                params: { challengeId: item.id }
              });
            }
          });
        }
      } catch (error) {
        this.errorCreatingChallenge = true;
      }
      this.submitClicked = false;
    }
  }
};
</script>

<style lang="sass" scoped>
#challenge-builder-review
  position: relative
  ul
    list-style-type: none
    li
      margin-bottom: 10px

  .controls
    margin-top: 1.5rem

  .review-section
    margin-left: 0
    margin-right: 0
    margin-top: 0
    padding: 5px
</style>
